/*******************************************************************************
 * Copyright (c) 2024. dnote.ai
 *
 * @project DNOTE.AI-Frontend
 * @author dnote.ai
 * @copyright Dnote.ai All rights reserved
 ******************************************************************************/

export const ADMINISTRATOR_CREATION_MODEL = {
    staffId         : null,
    firstName       : null,
    lastName        : null,
    username        : null,
    password        : null,
    confirmPassword : null,
    phone           : null,
    gender          : null,
    userType        : null,
}